<mat-toolbar class="subtitulo">Atendimento</mat-toolbar>

<div class="painel-principal" style="padding: 10px;">
    <form #formCadastro="ngForm">

        <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

            <!-- ATENDIMENTO-->
            <div fxLayout="column" fxFlex="30%">
                <mat-toolbar class="titulopartes">Atendimento</mat-toolbar>
                <mat-form-field style="margin: 0 20px 20px 20px">
                    <mat-label>Atendimentos:</mat-label>
                    <mat-select [(ngModel)]="participanteAtendimento.atendimento.id" name="atendimento" required>
                        <mat-option></mat-option>
                        <mat-option *ngFor="let i of atendimentos" [value]="i.id">
                            {{i.dataAtendimento | dataSimples}} - {{i.aluno.pessoaFisica.nome}}
                        </mat-option>
                    </mat-select>
                    <mat-hint *ngIf="atendimentos?.length === 0" align="start">Nenhum atendimento
                        cadastrado</mat-hint>
                </mat-form-field>
            </div>

            <!-- FAMILIARES-->
            <div fxLayout="column" fxFlex="30%">
                <mat-toolbar class="titulopartes">Familiar</mat-toolbar>
                <mat-form-field style="margin: 0 20px 20px 20px">
                    <mat-label>Familiares:</mat-label>
                    <mat-select [(ngModel)]="participanteAtendimento.familiar.id" 
                                 name="familiar"
                                 (selectionChange)=setFamiliar($event.value)>
                        <mat-option></mat-option>
                        <mat-option *ngFor="let i of familiares" [value]="i.id">
                            {{i.pessoasFisica.nome }}
                        </mat-option>
                    </mat-select>
                    <mat-hint *ngIf="familiares?.length === 0" align="start">Nenhum familiar
                        cadastrado</mat-hint>
                </mat-form-field>
            </div>

            <!-- FUNCIONARIO-->
            <div fxLayout="column" fxFlex="30%">
                <mat-toolbar class="titulopartes">Funcionário</mat-toolbar>
                <mat-form-field style="margin: 0 20px 20px 20px">
                    <mat-label>Funcionarios:</mat-label>
                    <mat-select [(ngModel)]="participanteAtendimento.funcionario.id" 
                                name="funcionario" 
                                (selectionChange)=setFuncionario($event.value)
                                required>
                        <mat-option></mat-option>
                        <mat-option *ngFor="let i of funcionarios" [value]="i.id">
                            {{i.pessoasFisica.nome }}
                        </mat-option>
                    </mat-select>
                    <mat-hint *ngIf="funcionarios?.length === 0" align="start">Nenhum funcionário
                        cadastrado</mat-hint>
                </mat-form-field>
            </div>
            
        </div>

       <div *ngIf="participanteAtendimento.funcionario.id">
         <dados-funcionario [funcionario]="participanteAtendimento.funcionario"></dados-funcionario>
       </div>

       <div *ngIf="participanteAtendimento.familiar.id">
           <dados-familiar [familiar]="participanteAtendimento.familiar"></dados-familiar>
       </div>


        <!-- BOTOES -->
        <div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px"
            fxFlexFill>
            <button *ngIf="!isAtualizar && mostrarBotaoCadastrar" mat-raised-button name="botaoConfirmar" fxFlex="20%"
                color="primary" [disabled]="formCadastro.invalid" (click)="cadastrar()"> Cadastrar
            </button>

            <button *ngIf="isAtualizar && mostrarBotaoAtualizar" mat-raised-button name="botaoConfirmar" fxFlex="20%"
                color="primary" [disabled]="formCadastro.invalid" (click)="atualizar()">
                Atualizar
            </button>

            <button *ngIf="mostrarBotaoLimpar()" mat-raised-button fxFlex="20%" (click)="limpar()">
                Limpar
            </button>
            <button mat-raised-button fxFlex="20%" (click)="cancelar()">
                Cancelar
            </button>

        </div>
    </form>

</div>